import {gql, useLazyQuery, useQuery} from '@apollo/client';
import {Box} from '@mui/material';
import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Panel} from '../../components/Panel/Panel';
import {useQueryParams} from '../../hooks/useQueryParams';
import {
  GetReviewAccountId,
  GetReviewAccountIdVariables,
} from '../../schema-types/GetReviewAccountId';
import {OneViewModelTypesEnum} from '../../schema-types/globalTypes';
import {
  GetNativeIdFromCuro,
  GetNativeIdFromCuroVariables,
} from '../../schema-types/GetNativeIdFromCuro';
import {GET_NATIVE_ID_FROM_CURO} from './TestHomepage';
import validateUUID from '../../utils/validateUUID';

export const TestReviewPage: React.FC = () => {
  const {reviewCuroId} = useParams();
  const params = useQueryParams();
  const curoId = validateUUID(reviewCuroId);
  const {data, loading} = useQuery<GetNativeIdFromCuro, GetNativeIdFromCuroVariables>(
    GET_NATIVE_ID_FROM_CURO,
    {
      variables: {
        curoId: curoId!,
        modelName: OneViewModelTypesEnum.REVIEW,
      },
      skip: !curoId,
    }
  );

  const [onFetchReviewId] = useLazyQuery<GetReviewAccountId, GetReviewAccountIdVariables>(
    gql`
      query GetReviewAccountId($id: UUID!) {
        reviewDetails(valueId: $id, keyId: "id") {
          id
          account {
            id
          }
        }
      }
    `
  );

  useEffect(() => {
    async function go() {
      if (data?.nativeId) {
        const {data: reviewData} = await onFetchReviewId({
          variables: {
            id: data.nativeId,
          },
        });
        if (reviewData) {
          const goTo = params.get('goTo') || 'reviews';
          navigate({
            pathname: `/account/${reviewData.reviewDetails?.account?.id}/review-journey/${data.nativeId}/${goTo}`,
          });
        }
      }
    }
    go();
  }, [data?.nativeId]);
  const navigate = useNavigate();
  return (
    <div>
      <Panel title="Account test setup">
        {loading ? <Box>Setting up test</Box> : null}
      </Panel>
    </div>
  );
};
